var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisputedTransactionsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#FEF0C7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7 32.24C13.71 32.23 13.71 32.22 13.71 32.22L19.21 26.72C19.22 26.71 19.23 26.71 19.24 26.7C18.61 26.26 17.84 26 17 26C14.79 26 13 27.79 13 30C13 30.75 13.21 31.46 13.58 32.06C13.62 32.12 13.66 32.18 13.7 32.24Z",
    fill: "#FDB022"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3 27.75C20.29 27.76 20.29 27.77 20.28 27.78L14.78 33.28C14.77 33.29 14.76 33.29 14.75 33.3C15.39 33.74 16.16 34 17 34C18.46 34 19.73 33.22 20.42 32.06C20.79 31.46 21 30.75 21 30C21 29.16 20.74 28.39 20.3 27.75Z",
    fill: "#FDB022"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29 16H19C16 16 14 17.5 14 21V24.56C14 24.93 14.38 25.16 14.71 25.01C15.69 24.56 16.82 24.39 18.01 24.6C20.64 25.07 22.57 27.51 22.5 30.18C22.49 30.6 22.43 31.01 22.32 31.41C22.24 31.72 22.49 32.01 22.81 32.01H29C32 32.01 34 30.51 34 27.01V21C34 17.5 32 16 29 16ZM24 26.5C22.62 26.5 21.5 25.38 21.5 24C21.5 22.62 22.62 21.5 24 21.5C25.38 21.5 26.5 22.62 26.5 24C26.5 25.38 25.38 26.5 24 26.5ZM31.25 26C31.25 26.41 30.91 26.75 30.5 26.75C30.09 26.75 29.75 26.41 29.75 26V22C29.75 21.59 30.09 21.25 30.5 21.25C30.91 21.25 31.25 21.59 31.25 22V26Z",
    fill: "#FDB022"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisputedTransactionsIcon);
export default __webpack_public_path__ + "static/media/disputed-transactions-icon.f0f958c77945adab273cf9ce4b2b3f1a.svg";
export { ForwardRef as ReactComponent };